import axiosInstance from "./axiosInstance";
import { showAlertError, showAlertExito, showAlertInfo } from '../utils/alertHelper';

const cocinaInsumo = 'cocinaInsumo';


// listando cocinaInsumo lazy
export const listcocinaInsumoLazy = async (page, limit, buscar) => {
  try {
    const response = await axiosInstance.get(`/${cocinaInsumo}/lazy/${page}/${limit}/${buscar}`);
    return response.data;
  } catch (error) {
    showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
  }
};


// agregando nuevos cocinaInsumo
export const createcocinaInsumo = async (data) => {
  try {
    const response = await axiosInstance.post(`/${cocinaInsumo}/create`, data);
    showAlertExito("¡Éxito!", "Producto creado exitosamente");
    return response.data;
  } catch (error) {
    showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
  }
};

// agregando nuevos cocinaInsumo
export const updatecocinaInsumo = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/${cocinaInsumo}/edit/${id}`, data);
    showAlertExito("¡Éxito!", "Producto actualizado exitosamente");
    return response.data;
  } catch (error) {
    showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
  }
};


// crando la receta 
export const createReceta = async (data) => {
  try {
    const response = await axiosInstance.post(`/${cocinaInsumo}/receta/create`, data);
    if (response.status === 200) {
      showAlertExito("¡Éxito!", "Receta creada exitosamente");
    } else {
      showAlertError("Error inesperado", "Verifique que el producto no tenga una receta creada previamente");
    }
    return response.data;
  } catch (error) {
    showAlertInfo("Información", "Verifique que el producto no tenga una receta creada previamente.");
  }
};


// actualizando receta
export const updateReceta = async (id, data) => {
  try {
    const response = await axiosInstance.put(`/${cocinaInsumo}/receta/edit/${id}`, data);
    showAlertExito("¡Éxito!", "Receta actualizada exitosamente");
    return response.data;
  } catch (error) {
    showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
  }
};


// listando recetas lazy
export const listRecetasLazy = async (page, limit, buscar) => {
  try {
    const response = await axiosInstance.get(`/${cocinaInsumo}/receta/lazy/${page}/${limit}/${buscar}`);
    return response.data;
  } catch (error) {
    showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
  }
};

// eliminando receta
export const deleteReceta = async (id) => {
  try {
    const response = await axiosInstance.delete(`/${cocinaInsumo}/receta/delete/${id}`);
    showAlertExito("¡Éxito!", "Receta eliminada exitosamente");
    return response.data;
  } catch (error) {
    showAlertError("Error inesperado", "Ocurrió un problema, intenta más tarde.");
  }
};

